import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuthGuard = (requiredRole) => {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(({ data }) => {
        if (data.must_change_password) {
          nav("/change-password");
        } else if (data.role !== requiredRole) {
          nav(data.role === "packager" ? "/packager" : "/admin");
        } else {
          setUser(data);
        }
      })
      .catch(() => nav("/admin/login"));
  }, [nav, requiredRole]);

  return user;
};
